module.exports = __webpack_public_path__ + "static/img/sex-1.fe19ffe5.png";